
  export default {
    mounted() {
      if (this.dismissed()) this.hide();

      this.el.addEventListener("click", (event) => {
        if (!event.target.closest("[data-dismiss]")) return;
        this.remember();
        this.hide();
      });
    },

    // The root layout reads the same entry to hide the card before it paints.
    storageKey() {
      return `phx:dismissed:${this.el.dataset.dismissKey}`;
    },

    dismissed() {
      try {
        return sessionStorage.getItem(this.storageKey()) === "1";
      } catch (_error) {
        return false;
      }
    },

    // Storage can be unavailable (private browsing, blocked cookies); the
    // card still hides for this page view.
    remember() {
      try {
        sessionStorage.setItem(this.storageKey(), "1");
      } catch (_error) {
        return;
      }
    },

    hide() {
      this.js().hide(this.el);
    },
  };
